module.exports = __webpack_public_path__ + "img/5.5c480331.png";